import { addCdnScript } from 'utils/addCdnScript'
import { getBooleanFromLocalStorage } from 'utils/localStorage/getBooleanFromLocalStorage'
import constants from 'utils/constants'
import config from 'config/env'

export const runApp = async () => {
  if (
    ['development', 'dev', 'qa-az'].includes(config.REACT_APP_ENV) &&
    getBooleanFromLocalStorage(constants.IS_USE_REACT_SCAN)
  ) {
    await addCdnScript('/react-scan.global.js')
  }

  if (
    process.env.NODE_ENV !== 'development' &&
    config.FIREBASE_ENABLED &&
    config.REACT_APP_ENV === 'qa-az'
  ) {
    await import('./services/FirebaseService')
  }

  await import('./initReact')
}
